module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-商业道德.c28165b0.png";